import {
	JsonEditor,
	createJSONEditor
}               from 'svelte-jsoneditor';
import * as STD from '@emersya/mpa-std';
import * as CM  from '@emersya/mpa-components-manager';

export interface IInputJSONComponentConfiguration extends IInputFormComponentConfiguration {
};

export class InputJSONComponent extends InputFormComponent<
	InputJSONComponent,
	IInputJSONComponentConfiguration
> {
	private editor!: JsonEditor;

	override async component_finalize() {
		await super.component_finalize();
		this.editor = createJSONEditor({
			target: this.component_DOM
		});
		void this.editor;
	};

	private onValueUpdated(event: STD.events.Event<any, CM.Component<any, any>>) {
		try {
			this.editor.set({
				json: event.details.newValue
			});
		} catch (error: any) {
			this.component_throwBoundError('Cannot update the value!', {
				value: event.details.newValue
			}, error);
		}
	};

	override deserialize(x: boolean) {
		return (x);
	};

	override isValueTheDefault() {
		return (false);
	};

	override async reset() {
		await super.reset();
		// await this.updateValue(this.configuration.defaultValue || null);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IInputJSONComponentConfiguration
	) {
		super(descriptor, configuration);
		this.addEventListener('value', this.onValueUpdated.bind(this), {
			subType: InputJSONComponent.type,
			listener: this
		});
	};
};
export namespace NS {
	export const Component = InputJSONComponent;
	export type Component = InputJSONComponent;
	export type Configuration = IInputJSONComponentConfiguration;
}
import {
	InputFormComponent,
	IInputFormComponentConfiguration
}               from '../InputForm/InputForm';
import './InputJSON.scss';

CM.Manager.declare({
	id: 'input-JSON',
	type: InputJSONComponent
});
